import { useEffect, useState } from 'react';
import { useTutorialWithNavigation } from '../hooks/useTutorial';
import { useTutorialContext } from '../context/TutorialContext';
import { TutorialStep } from './TutorialTooltip';
import { getSurveySteps } from '../services/survey/surveyService';

export function TutorialSetup() {
  const [tutorialSteps, setTutorialSteps] = useState<TutorialStep[]>([]);
  useTutorialWithNavigation();
  const { setSteps } = useTutorialContext();

  useEffect(() => {
    getSurveySteps("create-funnel-tutorial")
      .then((steps) => {
        setTutorialSteps(steps.data as TutorialStep[]);
      })
      .catch((error) => {
        console.error("Error getting survey steps:", error);
      });
  }, []);

  useEffect(() => {
    setSteps(tutorialSteps);
  }, [setSteps, tutorialSteps]);

  return null;
}
